import NewsBlock from "./NewsBlock";
import React, { StrictMode } from "react";
import ReactDOM from "react-dom/client";

const elements = document.querySelectorAll(".news-block__append");
if (elements.length > 0) {
  elements.forEach((element) => {
    const newsNumber = element.getAttribute("data-news-number");
    const newsCategory = element.getAttribute("data-news-category");
    const newsSize = element.getAttribute("data-news-size");
    const root = ReactDOM.createRoot(element);
    root.render(
      <StrictMode>
        <NewsBlock
          newsNumber={newsNumber}
          newsCategory={newsCategory}
          newsSize={newsSize}
        />
      </StrictMode>
    );
  });
}
